<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  .ml-5{
    margin-left: 5px;
  }
  .ml-10{
    margin-left: 10px;
  }
:root {
  --cog-primary: #4f46e5;
  --cog-primary-dark: #3730a3;
  --cog-primary-light: #818cf8;
  --cog-accent: #06b6d4;
  --cog-success: #10b981;
  --cog-warning: #f59e0b;
  --cog-danger: #ef4444;
  --cog-bg: #f1f5f9;
  --cog-card: #ffffff;
  --cog-sidebar: #1e293b;
  --cog-text: #1e293b;
  --cog-text-secondary: #64748b;
  --cog-text-muted: #94a3b8;
  --cog-border: #e2e8f0;
  --cog-border-light: #eef2f7;
  --cog-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);
  --cog-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  --cog-shadow-lg: 0 20px 50px rgba(15, 23, 42, 0.12);
  --cog-radius-sm: 6px;
  --cog-radius: 10px;
  --cog-radius-lg: 16px;
  --cog-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: var(--cog-bg);
}

body,
button,
input,
select,
textarea {
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', -apple-system, BlinkMacSystemFont, sans-serif;
}

* {
  box-sizing: border-box;
}

#app {
  min-height: 100%;
  color: var(--cog-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: inherit;
  text-decoration: none;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

.page-shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.page-title h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.page-title p {
  margin: 4px 0 0;
  color: var(--cog-text-secondary);
  font-size: 13px;
}

.stat-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background: var(--cog-card);
  border: 1px solid var(--cog-border-light);
  border-radius: var(--cog-radius-lg);
  transition: var(--cog-transition);
}

.stat-card:hover,
.card:hover,
.anchor-card:hover,
.policy-card:hover {
  box-shadow: var(--cog-shadow);
  transform: translateY(-2px);
}

.sc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  font-size: 22px;
  flex-shrink: 0;
}

.sc-icon.blue {
  background: #eef2ff;
  color: var(--cog-primary);
}

.sc-icon.cyan {
  background: #ecfeff;
  color: var(--cog-accent);
}

.sc-icon.gold {
  background: #fffbeb;
  color: var(--cog-warning);
}

.sc-icon.green {
  background: #ecfdf5;
  color: var(--cog-success);
}

.sc-icon.purple {
  background: #f5f3ff;
  color: #7c3aed;
}

.sc-info .sc-num {
  font-size: 28px;
  line-height: 1;
  font-weight: 800;
}

.sc-info .sc-label {
  margin-top: 6px;
  font-size: 13px;
  color: var(--cog-text-secondary);
}

.chart-row,
.two-col-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.card {
  background: var(--cog-card);
  border-radius: var(--cog-radius-lg);
  border: 1px solid var(--cog-border-light);
  padding: 24px;
  box-shadow: var(--cog-shadow-sm);
  transition: var(--cog-transition);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--cog-border-light);
}

.card-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
}

.table-wrap {
  overflow-x: auto;
  border: 1px solid var(--cog-border-light);
  border-radius: var(--cog-radius);
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  padding: 12px 14px;
  text-align: left;
  background: #f8fafc;
  color: var(--cog-text-secondary);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  white-space: nowrap;
  border-bottom: 2px solid var(--cog-border);
}

td {
  padding: 12px 14px;
  font-size: 14px;
  vertical-align: middle;
  border-bottom: 1px solid var(--cog-border-light);
}

tr:last-child td {
  border-bottom: none;
}

tr:hover td {
  background: #f8fafc;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 34px;
  padding: 8px 16px;
  border: none;
  border-radius: var(--cog-radius-sm);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--cog-transition);
}

.btn-primary {
  color: #fff;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
}

.btn-outline {
  color: var(--cog-primary);
  background: transparent;
  border: 1px solid var(--cog-primary);
}

.btn-success {
  color: #fff;
  background: var(--cog-success);
}

.btn-danger {
  color: #fff;
  background: var(--cog-danger);
}

.btn-warning {
  color: #fff;
  background: var(--cog-warning);
}

.btn-sm {
  min-height: 28px;
  padding: 5px 12px;
  font-size: 12px;
}

.btn-xs {
  min-height: 24px;
  padding: 3px 10px;
  font-size: 11px;
}

.status,
.tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-pending {
  background: #fef3c7;
  color: #b45309;
}

.status-approved {
  background: #ecfdf5;
  color: #059669;
}

.status-rejected {
  background: #fee2e2;
  color: #dc2626;
}

.status-reviewing {
  background: #eef2ff;
  color: var(--cog-primary);
}

.tag-blue {
  background: #eef2ff;
  color: var(--cog-primary);
}

.tag-purple {
  background: #f5f3ff;
  color: #7c3aed;
}

.tag-green {
  background: #ecfdf5;
  color: #059669;
}

.tag-orange {
  background: #fff7ed;
  color: #ea580c;
}

.tag-gray {
  background: #f3f4f6;
  color: #6b7280;
}

.tag-red {
  background: #fef2f2;
  color: #dc2626;
}

.search-bar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.search-bar input,
.search-bar select {
  min-width: 150px;
  min-height: 38px;
  padding: 9px 14px;
  border: 1.5px solid var(--cog-border);
  border-radius: var(--cog-radius-sm);
  font-size: 13px;
  outline: none;
  background: #fff;
}

.search-bar input:focus,
.search-bar select:focus {
  border-color: var(--cog-primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.06);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ii-label {
  font-size: 12px;
  color: var(--cog-text-muted);
}

.ii-value {
  font-size: 14px;
  font-weight: 500;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section h4 {
  margin: 0 0 10px;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid var(--cog-border-light);
}

.content-block {
  margin-bottom: 10px;
  padding: 16px;
  background: var(--cog-bg);
  border: 1px solid var(--cog-border-light);
  border-radius: var(--cog-radius);
}

.cb-label {
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--cog-primary);
}

.cb-value {
  font-size: 14px;
  line-height: 1.7;
}

.anchor-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.anchor-card,
.policy-card {
  background: var(--cog-card);
  border: 1px solid var(--cog-border-light);
  border-radius: var(--cog-radius-lg);
  transition: var(--cog-transition);
}

.anchor-card {
  padding: 20px;
  text-align: center;
}

.ac-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0 auto 12px;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}

.ac-avatar.av1 { background: linear-gradient(135deg, #6366f1, #8b5cf6); }
.ac-avatar.av2 { background: linear-gradient(135deg, #ec4899, #f43f5e); }
.ac-avatar.av3 { background: linear-gradient(135deg, #06b6d4, #3b82f6); }
.ac-avatar.av4 { background: linear-gradient(135deg, #f59e0b, #ef4444); }
.ac-avatar.av5 { background: linear-gradient(135deg, #10b981, #34d399); }

.ac-name {
  font-size: 15px;
  font-weight: 600;
}

.ac-type {
  margin-top: 4px;
  font-size: 13px;
  color: var(--cog-text-secondary);
}

.ac-fans {
  margin-top: 4px;
  font-size: 13px;
  color: var(--cog-primary);
  font-weight: 600;
}

.ac-actions,
.pc-actions {
  display: flex;
  gap: 6px;
  justify-content: center;
  flex-wrap: wrap;
}

.policy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.policy-card {
  padding: 24px;
  text-align: center;
}

.pc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin: 0 auto 12px;
  border: 2px dashed var(--cog-border);
  border-radius: 10px;
  overflow: hidden;
  background: var(--cog-bg);
}

.pc-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pc-title {
  font-size: 16px;
  font-weight: 600;
}

.pc-desc {
  margin: 6px 0 12px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--cog-text-secondary);
}

.banner-preview {
  position: relative;
  overflow: hidden;
  border-radius: var(--cog-radius-lg);
  background: linear-gradient(135deg, #eef2ff 0%, #f0f9ff 30%, #f5f3ff 60%, #ecfeff 100%);
}

.banner-img-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 240px;
  overflow: hidden;
}

.banner-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.banner-placeholder h2 {
  margin: 0 0 8px;
  font-size: 32px;
  font-weight: 800;
}

.banner-placeholder h2 span {
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.banner-placeholder p {
  margin: 0;
  color: var(--cog-text-secondary);
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
}

.es-text {
  color: var(--cog-text-secondary);
  font-size: 14px;
}

.page-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 28px;
  border-radius: var(--cog-radius-lg);
  background: linear-gradient(135deg, #eef2ff 0%, #f0f9ff 42%, #ecfeff 100%);
  border: 1px solid rgba(129, 140, 248, 0.12);
  box-shadow: var(--cog-shadow-sm);
}

.page-hero__title {
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
}

.page-hero__desc {
  margin: 8px 0 0;
  color: var(--cog-text-secondary);
  font-size: 14px;
}

.panel-card,
.el-dialog,
.el-message-box,
.el-table,
.el-pagination,
.el-tree,
.el-breadcrumb,
.el-form,
.el-tabs__content,
.el-collapse-item__wrap {
  border-radius: var(--cog-radius-lg);
}

.el-main {
  padding: 0 !important;
}

.el-breadcrumb {
  padding: 14px 18px;
  border: 1px solid var(--cog-border-light);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: var(--cog-shadow-sm);
}

.el-breadcrumb__inner,
.el-breadcrumb__inner a,
.el-breadcrumb__separator {
  color: var(--cog-text-secondary) !important;
  font-weight: 500;
}

.user-search,
.stbgc,
.st-gbox,
.paybox,
.mod-btnbox,
.treeclass,
.ql-snow,
.el-table,
.el-tabs__content,
.el-collapse,
.el-form:not(.el-form--inline):not(.login-form) {
  background: var(--cog-card);
  border: 1px solid var(--cog-border-light);
  box-shadow: var(--cog-shadow-sm);
}

.user-search,
.stbgc,
.st-gbox,
.paybox,
.mod-btnbox,
.treeclass,
.el-tabs__content,
.el-collapse,
.el-form:not(.el-form--inline):not(.login-form) {
  border-radius: var(--cog-radius-lg);
}

.user-search,
.stbgc,
.mod-btnbox,
.treeclass,
.el-tabs__content,
.el-collapse,
.el-form:not(.el-form--inline):not(.login-form) {
  padding: 18px 20px;
}

.st-gbox,
.paybox {
  padding: 16px;
}

.user-search {
  margin-top: 16px;
}

.el-table {
  overflow: hidden;
}

.el-table th {
  background: #f8fafc !important;
  color: var(--cog-text-secondary);
  font-weight: 600;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid var(--cog-border-light);
}

.el-table::before {
  display: none;
}

.el-table .cell {
  line-height: 1.5;
}

.el-dialog {
  overflow: hidden;
  box-shadow: var(--cog-shadow-lg);
}

.el-dialog__header {
  padding: 20px 24px 12px;
  border-bottom: 1px solid var(--cog-border-light);
}

.el-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: var(--cog-text);
}

.el-dialog__body {
  padding: 20px 24px;
}

.el-dialog__footer {
  padding: 12px 24px 20px;
  border-top: 1px solid var(--cog-border-light);
}

.el-input__inner,
.el-textarea__inner,
.el-select .el-input__inner,
.el-input-number,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  border-radius: var(--cog-radius-sm);
  border-color: var(--cog-border);
  min-height: 40px;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: var(--cog-primary);
}

.el-button {
  border-radius: var(--cog-radius-sm);
  font-weight: 600;
}

.el-button--primary {
  border-color: transparent;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
}

.el-button--primary:hover,
.el-button--primary:focus {
  opacity: 0.94;
}

.el-card,
.el-collapse,
.el-tabs__content,
.el-message-box {
  border-color: var(--cog-border-light);
}

.el-switch.is-checked .el-switch__core {
  border-color: var(--cog-success);
  background-color: var(--cog-success);
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: var(--cog-primary);
}

.el-tag {
  border-radius: 999px;
}

@media (max-width: 768px) {
  .page-hero {
    flex-direction: column;
    padding: 20px;
  }

  .stat-cards,
  .chart-row,
  .two-col-grid,
  .info-grid {
    grid-template-columns: 1fr;
  }

  .page-hero__title {
    font-size: 24px;
  }

  .user-search,
  .stbgc,
  .mod-btnbox,
  .treeclass,
  .el-tabs__content,
  .el-collapse,
  .el-form:not(.el-form--inline):not(.login-form) {
    padding: 16px;
  }

  .search-bar input,
  .search-bar select {
    width: 100%;
    min-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue